import { render, staticRenderFns } from "./View.vue?vue&type=template&id=493597f1&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=493597f1&prod&lang=scss&scoped=true"
import style1 from "./View.vue?vue&type=style&index=1&id=493597f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493597f1",
  null
  
)

export default component.exports